var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13792 0H15.8621V2.75862H4.13792V0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2414 2.75862V0H20V2.75862H17.2414Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13792 4.13793H15.8621V15.8621H4.13792V4.13793Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75861 15.8621V4.13793H0V15.8621H2.75861Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.2414V20H2.75861V17.2414H0Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13792 17.2414H15.8621V20H4.13792V17.2414Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2414 17.2414V20H20V17.2414H17.2414Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.8621V4.13793H17.2414V15.8621H20Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75861 0H0V2.75862H2.75861V0Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridLayer);
export default __webpack_public_path__ + "static/media/GridLayer.103edae47bd534c5036a3a5203e1af12.svg";
export { ForwardRef as ReactComponent };